// extracted by mini-css-extract-plugin
export var adlist = "offers-module--adlist--JwtVJ";
export var card = "offers-module--card--AupNJ";
export var firstText = "offers-module--firstText--buQn9";
export var logo = "offers-module--logo--KJBHO";
export var logoAndRatings = "offers-module--logoAndRatings--PTL6j";
export var logoAndText = "offers-module--logoAndText--1xu1F";
export var number = "offers-module--number--bcMum";
export var rating = "offers-module--rating--albKr";
export var rating1 = "offers-module--rating1--HvhdJ";
export var rating15 = "offers-module--rating15--F1EMO";
export var rating2 = "offers-module--rating2--gdFfQ";
export var rating25 = "offers-module--rating25--RzFze";
export var rating3 = "offers-module--rating3--pNNRx";
export var rating35 = "offers-module--rating35--j2dFj";
export var rating4 = "offers-module--rating4--J5-+v";
export var rating45 = "offers-module--rating45--x-ETy";
export var richtext = "offers-module--richtext--kAHON";
export var secondText = "offers-module--secondText--LaqjD";
export var section = "offers-module--section--3QXwV";
export var showMore = "offers-module--showMore--HQFJx";
export var starRating = "offers-module--starRating--RC1Yn";